import { createHead } from '@unhead/vue/client';

export default createHead();
